import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';

import { queryKeys } from 'api/config';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { showSuccessToast } from 'shared/components/Toast';

export const useRescheduleSessionMutation = (
  sessionId: string,
  options?: any
) => {
  const { request } = useMutationHTTPRequest();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const prevSessionId = searchParams.get('prevSessionId');

  return useMutation<
    any,
    { name: string },
    { reason?: string; startAt: string }
  >(
    (data) => {
      return request({
        url: `/api/coach/coaching-sessions/${sessionId}/reschedule`,
        body: data,
      });
    },
    {
      onSuccess: () => {
        showSuccessToast('Session rescheduled successfully.');
        queryClient.removeQueries([queryKeys.coachSession, sessionId]);
        queryClient.removeQueries([queryKeys.coachSession, prevSessionId]);
      },
      ...options,
      retry: 0,
    }
  );
};
